import { useState } from 'react';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Button } from '@components/button';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { TextField } from '@components/text-field';
import { useToaster } from '@components/toaster';

import { api } from 'api';

import { Modal, useModal } from 'features/modals';
import { useStore } from 'models/Provider';

type Props = {
  closeModal: () => void;
};

export const AddUserAppModal = (props: Props) => {
  const { t } = useStore();
  const { closeModal } = props;
  const { showSuccess } = useToaster();
  const { showModal } = useModal();

  const [appName, setAppName] = useState('');

  const queryClient = useQueryClient();
  const submit = useMutation(() => api.users.createApp(appName), {
    onSuccess: (data) => {
      queryClient.invalidateQueries(['userApps']);
      showSuccess(t('modals.adduserapp.success'));
      showModal('USER_APP_CREDENTIALS', {
        clientId: data.clientId,
        clientSecret: data.clientSecret,
      });
    },
  });

  return (
    <Modal>
      <Modal.Header text={t('modals.adduserapp.header')} />
      <Stack space={4}>
        <Text text={t('modals.adduserapp.helptext')} color="purple80" />
        <Separator />
        <TextField label={t('modals.adduserapp.label')} onChange={setAppName} />
      </Stack>
      <Modal.Actions>
        <Button variant="secondary" onClick={closeModal} text={t('modals.adduserapp.cancel')} />
        <Button
          variant="primary-blue"
          isDisabled={appName === '' || submit.isLoading}
          onClick={() => submit.mutate()}
          text={t('modals.adduserapp.save')}
        />
      </Modal.Actions>
    </Modal>
  );
};
